import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Lookbook
  [types.GET_LOOKBOOK_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.GET_LOOKBOOK_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      data: payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_LOOKBOOK_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};